import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import Config from '../../config';
import api from '../../apis';
import moment from 'moment';
import { usePagination } from './helper';

import ReactTable from '../general/form-control/react-table';
import { useGlobalVariable } from '../../context/GlobalVariableProvider';
import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';
import { Modal } from 'antd';
import EventArticle from '../general/article/eventArticle';

import ArticalModal from '../general/modal';

const ResearchReportTbl = ({

    requestOnRender=false,
    type=null
}:any) => {
   // const { initFilter,filterParams }:any = useGlobalVariable();
    const { filterParams } = useFilter();
    const { tablePagination, setTablePagination } = usePagination();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [_inputs, _setInputs] = useState({});

    const [modelProps, setModelProps] = useState({});
    const [openModel, setOpenModel] = useState(false);

    useEffect(() => {
    }, []);

    useEffect(() => {
        handleFilter(filterParams)
    }, [filterParams]);

    const handleFilter = (filterParams:any)=>{
        requestTableData(1,filterParams);
    }

    const requestTableData = async (cPage=1,inputs:any={}) =>{
        inputs['page'] = cPage;
   
        setLoading(true)
        let result = await api.getResearchList(inputs);
       
        if(result.researches){
            setTableData(result.researches)
        }else{
            setTableData([])
        }

        
        if (result.total) {
            // handlePagination('currentPage', cPage);
            // handlePagination('totalRecords', result.total);
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }

       setLoading(false)
        // console.log("getTradeHistoryLogs",result)
    }

    const tblColumns = useMemo(
        () => [
            {
                Header: 'Date',
                accessor: 'b_publish_date_start',
                Cell: (data: any) => {
                    if(!data.value) return;
                    return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                },
             
            },
            {
                Header: 'Country',
                accessor: 'country',

            },
            {
                Header: 'Category',
                accessor: 'category',

            },
            {
                Header: 'Title',
                accessor: 'title',
                Cell: (data: any) => {     
                    let row = {...data.row.original}
                 //  console.log("row12345",row)

                    row.file_content = row.file_content ?  Config.publicFileUrl + row.file_content:""
                    return <u className='cursor-pointer' onClick={()=>handleSelectArticle(row)}>{row?.title}</u>;
                },
            },

       
        ],
        []
    );

    const handleSelectArticle = (row:any) => {
        let url = "/api/broadcast/research/"+ row.b_id
        //open in new tab
        //window.open(row.file_content, '_blank');
        window.open(url, '_blank');
        
        // setModelProps(row)
        // setOpenModel(true)
    }


    return (
        <>
            <ReactTable
                // headerStyle={{
                //     background: 'rgba(210, 209, 209, 1)',
                //     color:"black"
                // }}
                columns={tblColumns}
                data={tableData}
                loading={loading}
                size='small'
                borderSeparate={true}
                pageSize={10}
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                pageChange={(cPage: number) => {
                    // showNotiLoader();
                    requestTableData(cPage,filterParams);
                }}
                hasPagination

            />
            <ArticalModal
                opened={openModel || false}
                onClosed={(openModel: boolean) =>
                    setOpenModel(openModel)
                }
            >
                {/* <TheWaitIsOverArticle /> */}
                <EventArticle {...modelProps} />
            </ArticalModal>
        </>
    );
};

export default ResearchReportTbl;
